// Zentraler Zugriffspunkt fuer die Authentifizierungs-Token im Frontend.
//
// Dies ist die EINZIGE Stelle, die direkt auf die localStorage-Schluessel der
// Token zugreift. Dadurch ist die Speicherstrategie an genau einem Ort
// aenderbar (z.B. spaeterer Umstieg auf HttpOnly-Cookies), ohne die zahlreichen
// Konsumenten (api.ts, apollo.ts, Router-Guard, Kendo-XHR, Login/Logout,
// Excel-Export usw.) einzeln anpassen zu muessen.

const TOKEN_KEY = 'token'
const JSON_WEB_TOKEN_KEY = 'jsonWebToken'
const SEMAPHORE_TOKEN_KEY = 'semaphore_token'

// Der DRF-Token wird inkl. 'Token '-Prefix abgelegt, weil der Wert unveraendert
// als Authorization-Header verwendet wird.
const AUTH_HEADER_PREFIX = 'Token '

/**
 * Authorization-Header-Wert (inkl. 'Token '-Prefix), wie er fuer REST-Requests
 * gesetzt wird. `null`, wenn kein Token vorhanden ist.
 */
export function getAuthHeaderValue(): string | null {
  return localStorage.getItem(TOKEN_KEY)
}

/** Speichert den DRF-Token-Key; der Authorization-Prefix wird ergaenzt. */
export function setToken(tokenKey: string): void {
  localStorage.setItem(TOKEN_KEY, AUTH_HEADER_PREFIX + tokenKey)
}

/**
 * Roher Token-Key ohne 'Token '-Prefix (z.B. fuer den externen Export-Service,
 * der den Wert nicht als Header erhaelt). Leerstring, wenn kein Token vorhanden.
 */
export function getRawToken(): string {
  return (localStorage.getItem(TOKEN_KEY) ?? '').replace(AUTH_HEADER_PREFIX, '')
}

/** True, wenn ein nicht-leerer Token hinterlegt ist. */
export function hasToken(): boolean {
  return !!localStorage.getItem(TOKEN_KEY)
}

/**
 * Auth-Wert fuer GraphQL/Apollo: bevorzugt `jsonWebToken`, faellt sonst auf den
 * REST-Token zurueck. `null`, wenn keiner vorhanden ist.
 */
export function getGraphqlAuthValue(): string | null {
  return localStorage.getItem(JSON_WEB_TOKEN_KEY) || localStorage.getItem(TOKEN_KEY)
}

/**
 * Semaphore-Feature-Flag ('SEMAPHORE_ENABLED' oder null). Kein Geheimnis –
 * steuert lediglich die Sichtbarkeit der Semaphore-Funktion.
 */
export function getSemaphoreToken(): string | null {
  return localStorage.getItem(SEMAPHORE_TOKEN_KEY)
}

/** Setzt das Semaphore-Feature-Flag. */
export function setSemaphoreToken(value: string | null): void {
  localStorage.setItem(SEMAPHORE_TOKEN_KEY, value as string)
}

export function removeToken(): void {
  localStorage.removeItem(TOKEN_KEY)
}

export function removeJsonWebToken(): void {
  localStorage.removeItem(JSON_WEB_TOKEN_KEY)
}

export function removeSemaphoreToken(): void {
  localStorage.removeItem(SEMAPHORE_TOKEN_KEY)
}
